import React, { useState, useEffect, useMemo } from 'react';
import { TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../styles/tailwind';
import Icon from '../components/IcomoonIcon';



export default function SearchInput({
  placeholder = 'Buscar...',
  onChange,
  value,
  disabled = false,
  style = {},
}) {
  const [textValue, setTextValue] = useState(value);

  useEffect(() => {
    setTextValue(value)
  }, [value]);

  function clearField() {
    setTextValue("")
    onChange?.("")
  }

  return (
    <View style={tw.style(``, style.container)}>
      <TextInput
        style={tw.style(`bg-white rounded-full px-6 py-2 pl-10 pr-10`, style.input)}
        placeholder={placeholder}
        placeholderTextColor={tw.color('gray-400')}
        onChangeText={value => {
          setTextValue(value)
          onChange?.(value)
        }}
        value={textValue}
        editable={!disabled}
      />

      <View style={tw`absolute left-0 top-0 bottom-0 justify-center pl-3`} pointerEvents="none">
        <Icon name='search' color={tw.color('secondary')} size={18} />
      </View>

      {
        !!textValue && !disabled &&
          <TouchableOpacity
            style={tw`absolute right-0 top-0 bottom-0 justify-center pr-3`}
            onPress={clearField}
            disabled={disabled}
            accessibilityLabel="Borrar campo"
          >
            <View style={tw`bg-red rounded-full w-4 h-4 items-center justify-center`}>
              <Icon name='cancel' color={tw.color('white')} size={8} />
            </View>
          </TouchableOpacity>
      }
    </View>
  )
}